import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { CircleLegend } from '@components/Legend'
import { IPAvailabilityLegends } from './interface'
import { Legends, LegendWrapper } from './style'

const AvailabilityLegends: React.FC<IPAvailabilityLegends> = ({ fullWidth, baseLabel, flexLabel, timeOffLabel }) => (
  <Legends fullWidth={fullWidth}>
    <LegendWrapper className="base">
      <CircleLegend color="green10" borderColor="green100" small disableMargin>
        <FormattedMessage id={`${baseLabel || 'Base'}`} />
      </CircleLegend>
    </LegendWrapper>
    <LegendWrapper className="flex">
      <CircleLegend color="warning10" borderColor="warning100" small disableMargin>
        <FormattedMessage id={`${flexLabel || 'Flex'}`} />
      </CircleLegend>
    </LegendWrapper>
    <LegendWrapper className="time-off">
      <CircleLegend color="white" borderColor="gray100" small disableMargin>
        <FormattedMessage id={`${timeOffLabel || 'Time off'}`} />
      </CircleLegend>
    </LegendWrapper>
  </Legends>
)

export default AvailabilityLegends
